var waypoint = new Waypoint({
  element: $('.animate__animated.up'),
  handler: function(direction) {
    $('.animate__animated.up').addClass('animate__bounceInUp');
  },
  offset: '100%'
})